import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginPayload, LoginResponse } from '../models/user.model';
import { CookieService } from 'ngx-cookie-service';
import { InvoiceResponse } from '../models/invoice.model';
import { ApiMethodService } from '../../tools/services/api/method-api/apiMethod.service';

@Injectable({
  providedIn: 'root',
})
export class ApiMasterService {
  private baseUrl = `${environment.apiPrivateUrl}`;
  token = '';
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private apiMethodService: ApiMethodService,
  ) {
    this.token = this.cookieService.get('token');
  }

  getInvoiceList(
    siteId: number,
    customerId: number,
  ): Observable<InvoiceResponse[]> {
    const token = this.cookieService.get('token');

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const params = new HttpParams()
      .set('siteId', siteId.toString())
      .set('customerId', customerId.toString());

    return this.http.get<InvoiceResponse[]>(
      `${this.baseUrl}/backoffice/GetInvoiceFromCustomer`,
      {
        headers: headers,
        params: params,
      },
    );
  }
}
